// extracted by mini-css-extract-plugin
export default {"heading":"heading--Vj0JJ","icon":"icon--jwU5i"};